import Swal from 'sweetalert2';

export const NotificacionesMixin = {
  methods: {
    mostrarNotificacion(icon, title) {
      
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
      });

      Toast.fire({
        icon: icon,
        title: title
      });
    }
  }
};
